/**
 * AZIENDE COLLEGATE (fino al 16-10-2026 «Holding») — la pagina del gruppo: l'albero delle aziende e i legami fra loro.
 *
 * ⚠️ Fino al 23-09-2026 questa rotta era anche la scheda dell'azienda, con diciotto sezioni.
 * Le sezioni sono diventate due voci di menu che lavorano sull'azienda in cui si è entrati
 * («Dati dell'azienda», «Regole di lavoro»); qui resta il gruppo, che è l'unico posto in cui si
 * apre un'**altra** azienda — e dove quindi si comincia a lavorare fuori casa.
 */
import { createFileRoute } from '@tanstack/react-router';
import { parseCompanySearch } from '@/features/tenants/companySearch';
import { CompanyPage } from '@/features/tenants/CompanyCard';

export const Route = createFileRoute('/_app/organization/company')({
  /* ⚠️ Senza `validateSearch` TanStack scarta i parametri: la scelta non sopravviverebbe a un
     ricaricamento, e le segnalazioni non potrebbero puntare a una sezione. La lettura sta in
     `features/tenants/companySearch`, dove si può provare senza montare la pagina — vedi lì
     il difetto che ha insegnato la lezione. */
  validateSearch: parseCompanySearch,
  component: CompanyPage,
});
